import form from 'skin/store/form';
import './style.css';
import { shadow } from 'skin/event';
import { observer } from 'mobx-react-lite';
import m from 'skin/store/mb';

const View = ({ setOn, current, pgCount }) => {
	const mb = m.isMobile;
	let cls = ['skin-form-head-ttl-com-view', 'form-head-ttl-com-view'];
	cls = cls.join(' ');

	if (!pgCount || pgCount < 3) return null;
	// Данные по текущей странице
	const view = form.getPage(current.page);

	let title = view?.title ?? '';

	if (current.page && !title) {
		title = 'Экран ' + current.page;
	}

	const st = { backgroundImage: 'url(skin/img/tb_view.svg)' };
	const st2 = {backgroundImage: 'url(skin/img/com_tb_view.svg)', height:'20px', width: '20px', border:'none'}
	return (
		<>
			{!mb && 
			<div className={cls} style={st} onClick={open}>
				{title}
			</div>}
			{mb && 
				<div style={{display:'flex'}} onClick={open}>
					<span className='ico' style={st2}></span>
					{title}
				</div>
			}
		</>
		
	);
	function open() {
		shadow(true);
		setOn(true);
	}
};

export default observer(View);
